

import React, { memo } from 'react';
import ImagePreview from '../ImagePreview';
import getDarkModeImageProps from '../../utils/getDarkModeImageProps';
import ICON_MAP from '../../../../common/constants/fileTypeIconMap';










function getIcon(type, assetMissing, assetError, asset) {
  if (!asset) {return 'corrupt';}

  if (assetMissing) {return 'faq';}

  if (assetError) {return 'fetcherror';}

  return ICON_MAP[type] || 'document';
}

function getSubtitle(asset, assetMissing, assetError) {
  if (!asset) {return 'Deleted';}

  if (assetMissing) {return 'Missing';}

  if (assetError) {return 'Error';}

  return '';
}

function OtherPreview(
{ asset, type, hideFileTypeIcon, darkMode, assetMissing, assetError })
{
  const uploadingAsset = {
    ...asset,
    assetFiles: { ORIGINAL: { type: 'ORIGINAL', sourceUrl: '', assetFileId: '', status: '' } }
  };
  const assetUploaded = asset && (asset.loadedPercent === void 0 || asset.loadedPercent === 100);
  const colourMap = getDarkModeImageProps({ darkMode });
  const assetInErrorState = !asset || assetMissing || assetError;

  return (
    <ImagePreview
      asset={uploadingAsset}
      hideFileTypeIcon={hideFileTypeIcon || !asset}
      imageProps={{
        defaultImageIcon: getIcon(type, assetMissing, assetError, asset),
        defaultIconBackground: assetUploaded || assetInErrorState ? colourMap.background : void 0,
        defaultIconColour: assetUploaded || assetInErrorState ? colourMap.icon : void 0,
        defaultIconSize: assetInErrorState ? 40 : void 0,
        defaultIconSubtitle: getSubtitle(asset, assetMissing, assetError)
      }}
      type={type} />);


}

export default memo(OtherPreview);